import * as React from "react";
import { RadioOrCheckListField } from "../../../../components/editors";
import { ModalForm } from "../../../../components/modal";
import { ComponentWithValidatedForm, ValidatedForm } from "../../../../components/validation";
import * as Forms from "../../../../forms";
import { SelectItem } from "../../../../models/editors";
import { SearchFilter } from "../../../../models/search";
import { Api } from "../../../../services/Api";

interface OwnProps {
    api: Api;
    onError?: (error: string) => void;
    onProcessing?: () => void;
    onUpdated?: (updatedAbstractIds: number[], selectedId?: number) => void;
}

interface OwnState {
    selectedAbstractIds: number[];
    show: boolean;
    groups: SearchFilter[];
}

export class UpdateGroupModal extends ComponentWithValidatedForm<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);

        const formModel = new Forms.AdminAbstract.AbstractsGroupUpdate();
        this.state = {
            ...this.getInitialState(formModel),
            selectedAbstractIds: [],
            show: false,
            groups: [],
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    public close() {
        this.setState({ ...this.state, show: false });
    }

    public show(groups: SearchFilter[], selectedAbstractIds: number[]) {
        const formModel = new Forms.AdminAbstract.AbstractsGroupUpdate();
        this.setState({ ...this.state,
            ...this.getInitialState(formModel),
            selectedAbstractIds,
            show: true,
            groups,
        });
    }

    public async onSubmit(model: Forms.AdminAbstract.AbstractsGroupUpdateData) {
        this.toggleProcessing(true);
        console.log("chosen group", model.gradingGroupId, !model.gradingGroupId ? null : model.gradingGroupId);

        const updateResult = await this.props.api.put<any>(Api.endpoints.admin.abstract.abstractGradingGroup, {
            body: JSON.stringify({
                abstractIds: this.state.selectedAbstractIds,
                gradingGroupId: !model.gradingGroupId ? null : model.gradingGroupId,
            }),
        });

        if (updateResult.isSuccess && updateResult.data) {
            if (this.props.onUpdated)
                this.props.onUpdated(this.state.selectedAbstractIds, !model.gradingGroupId ? undefined : model.gradingGroupId);
            this.close();
        }
        else {
            if (this.props.onError)
                this.props.onError(updateResult.errors.join("; "));

            this.setFormErrors(updateResult.errors.length ? updateResult.errors : [updateResult.message || "Server error"]);
        }

        this.toggleProcessing(false);
    }

    public render() {
        const radioItems: SelectItem[] = this.state.groups.map((item) => {
            const selectItem: SelectItem = {
                selected: false,
                id: item.id,
                render: item.name,
            };
            return selectItem;
        });

        // add "none" item
        radioItems.push({
            selected: false,
            id: 0,
            render: "None",
        });

        return <ModalForm formComponent={this} onCancel={() => this.close()} processing={this.state.formProcessing} show={this.state.show} title="Assign to grading group">
            <p>Assign {this.state.selectedAbstractIds.length} selected abstract{this.state.selectedAbstractIds.length === 1 ? "" : "s"} to one of the following grading groups:</p>

            <ValidatedForm
                formComponent={this}
                model={this.state.formModel.data}
                onValidSubmit={this.onSubmit}
                schema={this.state.formModel.rules}
                ref={(ref: any) => this.form = ref}
            >

                <RadioOrCheckListField formComponent={this} items={radioItems} name="gradingGroupId" type="radio" />

            </ValidatedForm>
        </ModalForm>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/list/components/UpdateGroupModal.tsx